import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const AddBoards = ({ language, refs }) => {
    let boardMenu = [
        {
            id: 'tutorial.manageLibrary.addToLibrary.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.addToLibrary.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.addToLibrary.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.addToLibrary.explanation3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/SaveBoard.png`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLibrary-addToLibrary'}
            title={'tutorial.manageLibrary.addToLibrary.title'}
            explanations={boardMenu}
            imageTop={false}
        />
    );
};

export default AddBoards;
